import ViewController from "core/views/view.controller";

export default class BranchSelectionCtrl extends ViewController {
    static $inject = ['$scope', '$state', 'settings', 'Branches'];

    constructor() {
        super(...arguments);
        this.branches = [];
        this.selectedBranch = null;
    }

    $onViewBeforeEnter() {
        this.selectedBranch = null;

        this.Branches.all().then((branches)=> {
            this.branches = branches;
        });
    }

    selectBranch(branch) {
        this.selectedBranch = branch;
    }

    save() {
        if (!this.selectedBranch) {
            return;
        }

        this.settings.branch = this.selectedBranch;
        this.settings.save();
        this.$state.go('tab.dashboard');
    }

}



// WEBPACK FOOTER //
// ./src/modules/main/views/branch-selection/branch-selection.controller.js